import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { getCurrentSiteId } from '../../site/selectors';

import {
  ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__FAIL,
  ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__REQUEST,
  ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__SUCCESS,
} from '../actionTypes';

import {
  actionAddSiteTextsConfig,
  actionAddSiteTextsTranslations,
} from './index';


const actionLoadSiteTextsWithConfigSuccess = () => ({
  type: ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__SUCCESS,
});

const actionLoadSiteTextsWithConfigFail = error => ({
  type: ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__FAIL,
  payload: { error },
});

export const actionLoadSiteTextsWithConfigRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/site_translation/content_config/${getCurrentSiteId(getState())}`
    ).then(
      ({ config, translations }) => {
        dispatch(actionAddSiteTextsConfig(config));
        dispatch(actionAddSiteTextsTranslations(translations));

        dispatch(actionLoadSiteTextsWithConfigSuccess());
      },
      error => {
        dispatch(actionLoadSiteTextsWithConfigFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
